/**
 * Phase 3e.1 — Alarms API client.
 * Import this alongside the main api/index.ts to expose alarms.* endpoints.
 */
import { api } from './client';

export interface AlarmProfile {
  id: string;
  name: string;
  mqtt_topic: string;
  default_message: string;
  message_color: string;
  siren_duration_s: number;
  drive_gpio: boolean;
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface AlarmEvent {
  id: string;
  profile_id: string | null;
  profile_name: string;
  trigger_source: 'mqtt' | 'manual_test' | 'manual_clear';
  triggered_at: string;
  cleared_at: string | null;
  message_shown: string;
  payload: string | null;
  device_count: number;
  triggered_by_email: string | null;
}

export interface AlarmProfileInput {
  name?: string;
  mqtt_topic?: string;
  default_message?: string;
  message_color?: string;
  siren_duration_s?: number;
  drive_gpio?: boolean;
  enabled?: boolean;
}

export const alarms = {
  status: () => api<{ mqtt_connected: boolean }>('/alarms/status'),

  profiles: {
    list: () => api<{ profiles: AlarmProfile[] }>('/alarms/profiles'),
    create: (p: AlarmProfileInput) =>
      api<{ profile: AlarmProfile }>('/alarms/profiles', { method: 'POST', body: p }),
    update: (id: string, p: AlarmProfileInput) =>
      api(`/alarms/profiles/${id}`, { method: 'PATCH', body: p }),
    remove: (id: string) =>
      api(`/alarms/profiles/${id}`, { method: 'DELETE' }),
    test: (id: string) =>
      api<{ ok: true; eventId: string; deviceCount: number; messageShown: string }>(
        `/alarms/profiles/${id}/test`, { method: 'POST' }),
  },

  events: {
    list: (limit = 100) =>
      api<{ events: AlarmEvent[] }>(`/alarms/events?limit=${limit}`),
    clear: (id: string) =>
      api(`/alarms/events/${id}/clear`, { method: 'POST' }),
  },
};
